import * as React from 'react';
import { Redirect } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import { Permissions } from '@app/AppConstants';

import { Layout } from '@app/Components/Layout';

import { NotFound } from '@app/Pages/NotFound/NotFound';
import { NotFoundPerson } from '@app/Pages/NotFoundPerson/NotFoundPerson';
import { Forbidden } from '@app/Pages/Forbidden/Forbidden';
import { AzureAuth } from '@app/Components/AzureAuth';
import { Home } from '@app/Pages/Home/Home';
import { Loading } from './Components/Loading';
import { securityService } from './Services/SecurityService';
const HealthBoard = React.lazy(() => import('@app/Pages/HealthBoard/HealthBoard'));
const JobList = React.lazy(() => import('@app/Pages/JobList/JobList'));
const PersonReport = React.lazy(() => import('@app/Pages/PersonReport/PersonReport'));
const EmployeeSummaryReport = React.lazy(() => import('@app/Pages/EmployeeSummaryReport/EmployeeSummaryReport'));
const MasterData = React.lazy(() => import('@app/Pages/MasterData/MasterData'));
const SeniorityReport = React.lazy(() => import('@app/Pages/SeniorityReport/SeniorityReport'));
const Features = React.lazy(() => import('@app/Pages/Features/Features'));

const personHimselfGroupLayout = (
	<Layout>
		<Switch>
			<Route exact path={['/', '/person/:code']} component={Home} />
			{/*<Route path="/person/:code" component={PersonInfo} />*/}
			<Route path="/not-found-person" component={NotFoundPerson} />
			<Route path="/403" component={Forbidden} />
			<Route path="*" component={NotFound} />
		</Switch>
	</Layout>
);

const noGroupLayout = (
	<Layout>
		<Switch>
			<Route exact path="/403" component={Forbidden} />
			<Redirect to="/403" />
		</Switch>
	</Layout>
);

const EmptyPage = ()=> <div/>;

export default class Routs {
	static get routs() {
		let layout = noGroupLayout;

		if (!AzureAuth.isUserHasAnyRole) return layout;

		if (AzureAuth.isUserOnlyInCrewGroup) {
			layout = personHimselfGroupLayout;
		} else {
			layout = Routs.generateLayout();
		}

		return layout;
	}

	static generateLayout() {
		return (
			<Layout>
				<React.Suspense fallback={<Loading loading />}>
					<Switch>
						<Route exact path={['/', '/person/:code']} component={Home} />
						<Route path="/not-found-person" component={NotFoundPerson} />
						<Route path="/person-report" component={securityService.permissionsLoaded ? securityService.hasPermission(Permissions.ViewPersonReport) ? PersonReport : NotFound : EmptyPage} />
						<Route path="/seniority-report" component={securityService.permissionsLoaded ? securityService.hasPermission(Permissions.ViewSeniorityReport) ? SeniorityReport : NotFound : EmptyPage} />
						<Route path="/employee-summary-report" component={securityService.permissionsLoaded ? securityService.hasPermission(Permissions.ViewEmployeeSummaryReport) ? EmployeeSummaryReport : NotFound : EmptyPage} />
						<Route path="/health-board" component={HealthBoard} />
						<Route path="/job-list" component={JobList} />
						<Route path="/features" component={Features} />
						<Route path="/master-data" component={MasterData} />
						<Route path="/403" component={Forbidden} />
						<Route path="*" component={NotFound} />
					</Switch>
				</React.Suspense>
			</Layout>
		);
	}
}
